import { find } from 'lodash';

class PropertySelectController {
  constructor(propertiesService) {
    this.propertiesService = propertiesService;
  }

  $onInit(){
    this.propertiesService.findAll(-1).then(result => {
        this.propertylist = result;
        this.properties = (this.ngModel.$viewValue && Object.keys(this.ngModel.$viewValue).length ? this.ngModel.$viewValue : []);
    });
  }

  updateValue(isOpen = false){
    if (!isOpen) {
      this.ngModel.$setViewValue(this.properties);
      this.ngModel.$setTouched();
    }
  }

  delete(key){
    if (Object.keys(this.properties).length === 1){
        this.properties = [];
    }
    else{
        this.properties.splice(key, 1);
    }
    this.updateValue();
  }

  disableProperty(id){
    return find(this.properties, {'property_id': id});
  }
}

PropertySelectController.$inject = [ 'propertiesService' ];

export default PropertySelectController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.select.controller.js